/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiExternalAdGroupFromJSON, ApiExternalAdGroupToJSON, } from './ApiExternalAdGroup';
import { ApiExternalCampaignFromJSON, ApiExternalCampaignToJSON, } from './ApiExternalCampaign';
import { ApiMatchTypeFromJSON, ApiMatchTypeToJSON, } from './ApiMatchType';
import { ApiServiceFromJSON, ApiServiceToJSON, } from './ApiService';
import { ApiSessionFromJSON, ApiSessionToJSON, } from './ApiSession';
import { ApiSyncFromJSON, ApiSyncToJSON, } from './ApiSync';
export function ApiExternalClickFromJSON(json) {
    return ApiExternalClickFromJSONTyped(json, false);
}
export function ApiExternalClickFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adGroup': !exists(json, 'adGroup') ? undefined : ApiExternalAdGroupFromJSON(json['adGroup']),
        'campaign': !exists(json, 'campaign') ? undefined : ApiExternalCampaignFromJSON(json['campaign']),
        'clickHash': !exists(json, 'clickHash') ? undefined : json['clickHash'],
        'clickId': !exists(json, 'clickId') ? undefined : json['clickId'],
        'counter': !exists(json, 'counter') ? undefined : json['counter'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'externalAdGroupId': !exists(json, 'externalAdGroupId') ? undefined : json['externalAdGroupId'],
        'externalCampaignId': !exists(json, 'externalCampaignId') ? undefined : json['externalCampaignId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'matchType': !exists(json, 'matchType') ? undefined : ApiMatchTypeFromJSON(json['matchType']),
        'service': !exists(json, 'service') ? undefined : ApiServiceFromJSON(json['service']),
        'sessions': !exists(json, 'sessions') ? undefined : (json['sessions'].map(ApiSessionFromJSON)),
        'sync': !exists(json, 'sync') ? undefined : ApiSyncFromJSON(json['sync']),
        'syncId': !exists(json, 'syncId') ? undefined : json['syncId'],
    };
}
export function ApiExternalClickToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adGroup': ApiExternalAdGroupToJSON(value.adGroup),
        'campaign': ApiExternalCampaignToJSON(value.campaign),
        'clickHash': value.clickHash,
        'clickId': value.clickId,
        'counter': value.counter,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'externalAdGroupId': value.externalAdGroupId,
        'externalCampaignId': value.externalCampaignId,
        'id': value.id,
        'keywords': value.keywords,
        'matchType': ApiMatchTypeToJSON(value.matchType),
        'service': ApiServiceToJSON(value.service),
        'sessions': value.sessions === undefined ? undefined : (value.sessions.map(ApiSessionToJSON)),
        'sync': ApiSyncToJSON(value.sync),
        'syncId': value.syncId,
    };
}
